import { Injectable } from '@angular/core';
import { ApiHelperService } from '../../core/api-helper.service';
import { Role } from './role.model';

@Injectable({
    providedIn: 'root'
})
export class RoleService {

    options = { authenticate: true, setRoot: true };

    constructor(private api: ApiHelperService) {}

    getAllRoles(): Promise<Role[]>{
        return this.api.apiCallSane(
            '/roles',
            'GET',
            this.api.getDefaultHeaders(),
            null,
            null,
            this.options
        );
    }

    getNonAdminRoles(): Promise<Role[]> {
        return this.api.apiCallSane(
            '/roles',
            'GET',
            this.api.getDefaultHeaders(),
            { adminAccess: false },
            null,
            this.options
        );
    }

    getBillingRole(): Promise<Role> {
        return this.api.apiCallSane(
            '/role',
            'GET',
            this.api.getDefaultHeaders(),
            { name: 'organizationBillingAdmin' },
            null,
            this.options
        );
    }
}

